import { render } from "./BaseCollapse.vue?vue&type=template&id=1ac9a4bc&scoped=true&lang=pug"
import script from "./BaseCollapse.vue?vue&type=script&lang=js"
export * from "./BaseCollapse.vue?vue&type=script&lang=js"

import "./BaseCollapse.vue?vue&type=style&index=0&id=1ac9a4bc&scoped=true&lang=scss"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac9a4bc"]])

export default __exports__